import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type {
  CreatePayload,
  EditPayload,
  MovePayload,
  Thread,
  UpdatePayload,
} from './types'

export const ThreadsActions = {
  delete: createAction<WithId>('THREADS_DELETE_SAGA'),
  resolve: createAction<WithId>('THREADS_RESOLVE_SAGA'),
  reopen: createAction<WithId>('THREADS_REOPEN_SAGA'),
  edit: createAction<EditPayload>('THREADS_EDIT_SAGA'),
  move: createAction<MovePayload>('THREADS_MOVE'),
  create: createAction<CreatePayload>('THREADS_CREATE'),
  list: createAction<WithId>('THREADS_FETCH_LIST'),
}

export const InternalThreadsActions = {
  delete: createAction<WithId>('THREADS_DELETE'),
  set: createAction<Thread[]>('THREADS_SET'),
  add: createAction<Thread>('THREADS_ADD'),
  update: createAction<UpdatePayload>('THREADS_UPDATE'),
}
